import { enableObservabilityTrackIntegration } from '@gonfalon/constants/constants';
import { getDogfoodClient } from '@gonfalon/dogfood-client/getDogfoodClient';
import { LDObserve } from '@launchdarkly/observability';

import type { RUMCustomErrorContext } from '../types';

export function trackDogfoodError(
  error: Error,
  { isCrash, severity, url, owner, metadata, inflightExperiences }: RUMCustomErrorContext = {},
) {
  if (enableObservabilityTrackIntegration()) {
    recordError(error, { isCrash, severity, url, owner, metadata, inflightExperiences });
  }
  getDogfoodClient().track('Gonfalon frontend errors');

  if (isCrash) {
    getDogfoodClient().track('Gonfalon frontend crashes');
  }

  if (severity) {
    getDogfoodClient().track(`Gonfalon frontend ${severity} severity errors`);
  }
}

function recordError(
  error: Error,
  { isCrash, severity, url, owner, metadata, inflightExperiences }: RUMCustomErrorContext = {},
) {
  let stringifiedMetadata: string | undefined;
  let stringifiedInflightExperiences: string | undefined;

  try {
    if (metadata) {
      stringifiedMetadata = JSON.stringify(metadata, null, 2);
    }
    if (inflightExperiences) {
      stringifiedInflightExperiences = JSON.stringify(inflightExperiences, null, 2);
    }
  } catch (stringifyError) {
    if (stringifyError instanceof Error) {
      LDObserve.recordError(stringifyError, undefined, buildPayload({ url, owner }));
    }
  }

  LDObserve.recordError(
    error,
    undefined,
    buildPayload({
      isCrash,
      severity,
      url,
      owner,
      metadata: stringifiedMetadata,
      inflightExperiences: stringifiedInflightExperiences,
    }),
  );
}

function buildPayload(values: Record<string, unknown>): Record<string, string> {
  const payload: Record<string, string> = {};
  for (const [key, value] of Object.entries(values)) {
    if (value === undefined || value === null) {
      continue;
    }
    const stringified = typeof value === 'string' ? value : value.toString();
    if (stringified === '') {
      continue;
    }
    payload[key] = stringified;
  }
  return payload;
}
